import { Mail, Phone, Facebook, Linkedin, MapPin } from "lucide-react";
const ContactInfo = () => {
  return <div className="space-y-8">
      <div className="p-6 bg-gray-50 rounded-lg transition-all duration-200 hover:bg-gray-100">
        <h3 className="font-semibold text-lg mb-3">Get In Touch</h3>
        <p className="text-gray-600 mb-3">
          Need assistance? Our team is here to help! Whether you need expert advice or are looking for a specific part, we are happy to assist you.
        </p>
        <p className="text-primary font-medium">
          For quick responses, use our online inquiry form!
        </p>
      </div>

      <div className="space-y-6">
        <div className="p-6 bg-gray-50 rounded-lg transition-all duration-200 hover:bg-gray-100">
          <div className="flex items-start space-x-4">
            <MapPin className="h-6 w-6 text-primary mt-1" />
            <div>
              <h3 className="font-semibold mb-2 text-base">Address</h3>
              <p className="text-gray-600">
                P.S. Jain motor market, 69, Kashmere Gate,<br />
                Delhi, 110006, India
              </p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-gray-50 rounded-lg transition-all duration-200 hover:bg-gray-100">
          <div className="flex items-start space-x-4">
            <Mail className="h-6 w-6 text-primary mt-1" />
            <div>
              <h3 className="font-semibold mb-2 text-base">Email</h3>
              <a href="mailto:info@topmotorpart.com" className="text-gray-600 hover:text-primary">
                info@topmotorpart.com
              </a>
            </div>
          </div>
        </div>

        <div className="p-6 bg-gray-50 rounded-lg transition-all duration-200 hover:bg-gray-100">
          <div className="flex items-start space-x-4">
            <Phone className="h-6 w-6 text-primary mt-1" />
            <div>
              <h3 className="font-semibold mb-2 text-base">Phone</h3>
              <a href="tel:+919810391385" className="text-gray-600 hover:text-primary">
                +91 9810391385
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-6 border-t border-gray-200">
        <h3 className="font-semibold text-sm mb-4">Connect With Us</h3>
        <div className="flex space-x-4">
          <a href="https://www.facebook.com/profile.php?id=61572583258377" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-50 rounded-full text-gray-600 hover:text-primary hover:bg-gray-100 transition-all duration-200">
            <Facebook className="h-6 w-6" />
          </a>
          <a href="https://www.linkedin.com/company/top-motor-part/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-50 rounded-full text-gray-600 hover:text-primary hover:bg-gray-100 transition-all duration-200">
            <Linkedin className="h-6 w-6" />
          </a>
        </div>
      </div>
    </div>;
};
export default ContactInfo;